import { GiftCardsUtilService } from '@core/services/ib-gift-cards-utils.service';
import { RedirectionLandingService } from '@core/services/ib-gift-cards-redirection-service';
import { GiftCardsConfigurationService } from '@src/app/features/pages/configuration/services/ib-gift-cards-configuration/ib-gift-cards-configuration-service';
import angular from 'angular';
import { GiftCardsDatalayerService } from '@src/app/core/services/ib-gift-cards-datalayer-service';
import {GiftCardsRouterConstantsType} from '@src/app/core/routing/ib-gift-cards-router-constants';
import { CurrencyPipe } from '@angular/common';
import { CurrencyService } from 'ib-web-commons/dist/app/core/utils/ib-commons-currency-service';

const componentOptions = {
    bindings: {},
    controllerAs: 'giftCardsConfigurationContributionCtrl',
    templateUrl: ['GiftCardsAppConstants', (GiftCardsAppConstants: GiftCardsAppConstant): string => `${GiftCardsAppConstants.templatesRoute}ib-gift-cards-configuration-contribution-view.html`]
};
const componentInfo = {
    module: 'ib-gift-cards-configuration-module',
    selector: 'ibGiftCardsConfigurationContribution',
    inject:['$location', '$scope',
        '$timeout',  'localStorageService',
        'GiftCardsAppConstants',
        'GiftCardsUtilService',  'GiftCardsConfigurationService',
        'CommonsModalService', 'DatalayerUtilsService',  'RedirectionLandingService',
        'GiftCardsRouterConstants',  '$translate',
        '$filter', 'CommonsGetWcsPhonesService', 'IbCAuthTokenService', '$rootScope', 'CommonsKeepAliveUtilsService', 'IbCPermanentUserService', 'DigitalDataService',
        'GiftCardsDatalayerService', 'CurrencyService'],
    required: ['ib-gift-cards-configuration-form-module', 'ib-gift-cards-service-module']
};
export class ibGiftCardsConfigurationContribution implements ng.IController {
    public model: Types.ConfigurationModel;
    constructor (
        private $location: ng.ILocationService,
        private $scope: angular.IScope,
        private $timeout: ng.ITimeoutService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private GiftCardsAppConstants: GiftCardsAppConstant,
        private GiftCardsUtilService: GiftCardsUtilService,
        private GiftCardsConfigurationService: GiftCardsConfigurationService,
        private CommonsModalService: any,
        private DatalayerUtilsService: any,
        private RedirectionLandingService: RedirectionLandingService,
        private GiftCardsRouterConstants: GiftCardsRouterConstantsType,
        private $translate: angular.translate.ITranslateService,
        private $filter: angular.IFilterService,
        private CommonsGetWcsPhonesService: any,
        private IbCAuthTokenService: any,
        private $rootScope: CommonsRootScope,
        private CommonsKeepAliveUtilsService: CommonsKeepAliveUtilsService,
        private IbCPermanentUserService: IbCPermanentUserService,
        private DigitalDataService: any,
        private GiftCardsDatalayerService: GiftCardsDatalayerService,
        private CurrencyService: any ) {

    }
    active = (): any => {
        const paymentStatus = this.GiftCardsUtilService.getParameterByName(this.GiftCardsAppConstants.nameParameters.paymentStatus);
        const componentType = this.GiftCardsUtilService.getParameterByName(this.GiftCardsAppConstants.nameParameters.componentType);
        const code = this.GiftCardsUtilService.getParameterByName('code');
        const id = this.GiftCardsUtilService.getParameterByName('id');
        const redirectStatus = !!(paymentStatus === this.GiftCardsAppConstants.PAYMENTS.PAYMENTSTATUSOK || paymentStatus === this.GiftCardsAppConstants.PAYMENTS.PAYMENTSTATUSKO || componentType);
        const redirectionPaymentCallback: any = this.localStorageService.get('redirectionPaymentCallback');
        const isAfterLoginPermanentUser = this.IbCPermanentUserService.isAfterLoginPermanentUser();
        if ((redirectionPaymentCallback && redirectionPaymentCallback.status && redirectStatus) || isAfterLoginPermanentUser) {
            this.CommonsKeepAliveUtilsService.initKeepAlive();
            this.localStorageService.set('nextStepAllowed', true);
            if(!isAfterLoginPermanentUser) {
                angular.extend(redirectionPaymentCallback, {
                    redirectStatus: redirectStatus,
                    paymentStatus: paymentStatus === this.GiftCardsAppConstants.PAYMENTS.PAYMENTSTATUSKO ? false : paymentStatus === this.GiftCardsAppConstants.PAYMENTS.PAYMENTSTATUSOK || componentType || false
                });
                this.localStorageService.set('redirectionPaymentCallback', redirectionPaymentCallback);
                const datalayer_back = this.localStorageService.get('datalayer_general_Back');
                if (datalayer_back) {
                    this.DatalayerUtilsService.updateDatalayerWithQuadrigam(null, datalayer_back, this.GiftCardsUtilService.isUserLogged());
                }
            }
            this.GiftCardsDatalayerService.updateStepWithQuadrigam();
            this.$location.path(this.GiftCardsAppConstants.PAGES_ROUTES.PAYMENTS);
        } else {
            this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true);
            this.IbCAuthTokenService.getAnonymousToken().then(() => {
                this.CommonsGetWcsPhonesService.getPhoneByCode(this.GiftCardsAppConstants.WCS.PHONE_TYPES.SALES).then(() => {
                    this.$rootScope.phonesList = this.localStorageService.get('phonesList') || {};
                });
                
                this.GiftCardsUtilService.getContributionData(code, id).then((res: any) => {
                    this.model = this.GiftCardsConfigurationService.initializeModel();
                    res.transformedAmount = this.CurrencyService.formatPrice(
                        this.CurrencyService.getCurrencyObject(res.currency),
                        res.amount,
                        true
                    );
                    res.expirySimpleDate = this.GiftCardsUtilService.simplyDateFormater(res.expiryDate);
                    res.deliverySimpleDate = this.GiftCardsUtilService.simplyDateFormater(res.deliveryDate);
                    res.timeFromDeliveryDate = this.GiftCardsUtilService.extractTimeFromDate(res.deliveryDate);
                    this.model.contributionCardData = res;
                    this.nextStep();
                }).catch((error) => {
                    const modalError = this.GiftCardsAppConstants.CONTRIBUTION_ERRORS[error.data.code];
                    
                    this.CommonsModalService.showGenericModal(true, modalError,
                        { idModal: this.GiftCardsAppConstants.GIFT_CARDS_BACK }, null).result.then( () => {
                        this.RedirectionLandingService.redirection(this.GiftCardsAppConstants.market.toLowerCase(), this.GiftCardsAppConstants.lang.toUpperCase());
                    }, angular.noop);
                });

            }, () => {
                this.$location.path('/error');
            });
            this.localStorageService.remove('headerModel');

        }

    };
    $onInit = this.active();
    checkGroupAvailability = (availabilityResponse) => { 
        return availabilityResponse.groupCustomPrice ? true : false;
    };
    checkIfLongPrice = (availabilityResponse) => {
        
        return availabilityResponse.conditionInfo?.selectedCondition?.text?.length >= 9;
    };
    nextStep = () => {
        this.localStorageService.remove('redirectionPaymentCallback');
        this.localStorageService.remove('datalayer_general_Back');
        this.GiftCardsDatalayerService.updateStepWithQuadrigam();
        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true);
        this.GiftCardsConfigurationService.getAvailability(this.model.contributionCardData.amount, this.model.contributionCardData.flowId).then((availabilityResponse: Types.AvailabilityGiftCards) => {

            if(this.checkGroupAvailability(availabilityResponse)) {
                this.GiftCardsConfigurationService.getRouteParams(this.model, this.GiftCardsUtilService);
                this.model.importInfo = availabilityResponse;
                this.model.isLongPrice = this.checkIfLongPrice(availabilityResponse);
                this.DigitalDataService.addDigitalDataInfo({GiftCardCampaign: availabilityResponse?.conditionInfo?.campaigns[0]?.commercialCode ? availabilityResponse?.conditionInfo?.campaigns[0]?.commercialCode : 'sin campaña'});
                this.model.importGift = availabilityResponse.groupFixedPrices[0];
                this.model.themeGift.theme = this.GiftCardsAppConstants.THEME;
                this.model.destinataryInfo.message = this.$filter('translate')('GIFT_CARD_PREMESSAGE_RECEIVER');
                this.$timeout(() => {
                    this.CommonsModalService.finishWaiting();
                    this.CommonsModalService.closeAllCurrentModals();
                    this.$rootScope.$broadcast('sendUpdateToMonetate');
                    this.$rootScope.$broadcast('updateDatalayer');            
                    this.$rootScope.$broadcast('updateDigitalData');
                });
            }else {
                const modalError = 'ib-contribution-service-error-gift-cards-contribution.html';
                this.CommonsModalService.showGenericModal(true, modalError,
                    { idModal: this.GiftCardsAppConstants.GIFT_CARDS_BACK }, null).result.then( () => {
                    this.RedirectionLandingService.redirection(this.GiftCardsAppConstants.market.toLowerCase(), this.GiftCardsAppConstants.lang.toUpperCase());
                }, angular.noop);
            }
            
        }, (error: any) => {
            this.$timeout(() => {
                this.CommonsModalService.finishWaiting();
                this.CommonsModalService.closeAllCurrentModals();
                this.$location.path(this.GiftCardsRouterConstants.PAGES_URL.GIFTCARD_ERROR);
            });

        }).catch(() => {
            this.$timeout(() => {
                this.CommonsModalService.finishWaiting();
                this.CommonsModalService.closeAllCurrentModals();
            });
        });
    };
}
try {
    const mod = angular.module(componentInfo.module);
    ibGiftCardsConfigurationContribution.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsConfigurationContribution })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGiftCardsConfigurationContribution.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsConfigurationContribution })
    );
}
